import React from 'react'
import { Link } from 'react-router-dom'
import { SocialIcon } from 'react-social-icons';
import './footer.css'

const SubmitHandler = (e) => {
    e.preventDefault()
}

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const Footer = (props) => {
    return (
        <footer className={`wpo-site-footer ${props.ftClass}`}>
            <div className="wpo-upper-footer section-padding">
                <div className="container">
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-xs-12">
                            <ul>
                                <li>Copyright &copy; 2026 <Link onClick={ClickHandler} to="/">Janberk Altay</Link></li>
                                <li >
                                    <ul className='footer-social'>
                                        <SocialIcon target="_blank" rel="noopener noreferrer" url="https://github.com/janberkaltay" />
                                        <SocialIcon target="_blank" rel="noopener noreferrer" url="https://www.instagram.com/janberkaltay/" />
                                        <SocialIcon target="_blank" rel="noopener noreferrer" url="https://www.linkedin.com/in/janberkaltay/" />
                                        <SocialIcon target="_blank" rel="noopener noreferrer" url="https://www.youtube.com/channel/UCgkNm9R0i3NftVxcBv_Jqmg" />
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;